// extracted by mini-css-extract-plugin
export default {"type-default":"F3VUwVsNuWtp9ntktyJR","type-larger":"eija3LqneyGTIj_yTiow","fallback-background":"NifV9NMYE1H2r3JcZqrM","common_bganimation":"lkD05GHohF1hiKxS_BH6"};